'use strict';
        var _ = require('../dependency')._,
        config = require('../config'),
        $u = require('../utilities');
        var GRAPHS = config.graphs,
        $d = config.druid;


var chartId = 'UNIQUE_CONNECTIONS_BY_CUSTOMERS',
        chartType = 'POINT_IN_TIME',
        filters = [config.filters.DATE],
        dataRotateMapping = [{
                name: 'Public',
                field: 'amcNumOfUniqueGuestNetworkAssociations'
            }, {
                name: 'Private',
                field: 'amcNumOfUniqueCorporateNetworkAssociations'
            }],
        dataSeries = {
            TIMESTAMP: 'timestamp',
            PRIVATE_UNIQUE_CONNECTIONS: 'amcNumOfUniqueCorporateNetworkAssociations',
            PUBLIC_UNIQUE_CONNECTIONS: 'amcNumOfUniqueGuestNetworkAssociations'
        },
fieldNames = {
    PRIVATE_UNIQUE_CONNECTIONS: 'amcNumOfUniqueCorporateNetworkAssociations',
    PUBLIC_UNIQUE_CONNECTIONS: 'amcNumOfUniqueGuestNetworkAssociations'
},
/**
 * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
 * can be modified for other data provider systems.]
 * @type {Object}
 */
dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        aggregations: [{
                type: 'longSum',
                name: dataSeries.PUBLIC_UNIQUE_CONNECTIONS,
                fieldName: fieldNames.PUBLIC_UNIQUE_CONNECTIONS
            }, {
                type: 'longSum',
                name: dataSeries.PRIVATE_UNIQUE_CONNECTIONS,
                fieldName: fieldNames.PRIVATE_UNIQUE_CONNECTIONS
            }]
    }],
        dataSeriesFields = ['connectionType', 'connectionsCount'],
        modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
        aggregationFields = _.chain(dataSeries).values().without(dataSeries.TIMESTAMP).value(),
        tasks = [
            'durationFilter',
            'druidQueryGenerator',
            'druidQueryValidator',
            'fetchChartData',
            'druidResponseParser', {
                name: 'afterApiAggregationAverage',
                config: {
                    aggregationFields: aggregationFields
                }
            }, {
                plugin: modifyResponse
            }, {
                name: 'updateChartModelData',
                config: {
                    dataSeriesFields: dataSeriesFields,
                    modelFieldKeys: modelFieldKeys
                }
            }
        ];



exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.UNIQUE_CONNECTIONS_BY_CUSTOMERS;



function modifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
            computedModel = {},
            fieldLabel,
            fieldIndex;


    _.forEach(dataRotateMapping, function (singlePluginMapping) {
        fieldLabel = singlePluginMapping.name;
        fieldIndex = singlePluginMapping.field;

        if (!computedModel.connectionType) {
            computedModel.connectionType = [];
        }
        computedModel.connectionType.push(fieldLabel);

        if (!computedModel.connectionsCount) {
            computedModel.connectionsCount = [];
        }

        if (model[fieldIndex]) {
            computedModel.connectionsCount.push(parseInt(model[fieldIndex]));
        } else {
            computedModel.connectionsCount.push(0); // 0 or null value in connections count. so average will be 0
        }


        delete model[fieldLabel];
    });

    if ($u.charts.allEqualElemArray(computedModel.connectionsCount, 0) ||
            $u.charts.allEqualElemArray(computedModel.connectionsCount, null)
            ) {
        context.zeroDataFlag = true;
    }

    context.chartData = computedModel;
    next();
}


function chartTemplate(data, width) {
    /*!ToDo chech y width is a string in px*/
    width = parseInt(width.match(/\d+/g)[0], 10);

    var duration = data.__duration,
            xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
            x = xAxisLabelOffset.x,
            y = xAxisLabelOffset.y,
            legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false),
            pointWidth = width / 50;

    var yAxisBaseUnit = '',
            yAxisRoundOff = false,
            yAxisFormatter = $u.charts.chartYaxisFormatter,
            xAxisMaxChars = 15,
            yAxisTrimDecimalPlaces = 0;

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            duration: duration,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Connection Type'
        },
        chart: {
            type: 'column',
            zoomType: 'x,y',
            alignTicks: false,
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function () {
                    var dataUnit,
                            chartContext = this,
                            dataArray;

                    _.forEach(chartContext.yAxis, function (yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function (seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
                        yAxisObject.setTitle({
                            text: GRAPHS.CHART_METADATA.UNIQUE_CONNECTIONS_BY_CUSTOMERS.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                var that = this,
                        tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('Average {0} Unique Connections: {1} {2}',
                        that.x,
                        tooltipUnitObj.value,
                        tooltipUnitObj.unit
                        );
            },
            percentageDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data.connectionType,
            tickmarkPlacement: 'on',
            labels: {
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL,
                    width: '80px'
                },
                formatter: function () {
                    return this.value;
                },
                useHTML: false,
                autoTransform: true
            }
        },
        yAxis: [{
                title: {
                    text: '',
                    style: {
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                        color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                    }
                },
                allowDecimals: false,
                min: 0,
                maxPadding: 0,
                lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
                lineWidth: 1,
                labels: {
                    format: '{value}',
                    formatter: function () {
                        var that = this,
                                yAxisValue = that.value,
                                yMaxValue = that.axis.dataMax;
                        return yAxisFormatter(yAxisValue, yMaxValue,
                                yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces).value;
                    },
                    style: {
                        fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                    },
                    x: -20
                }
            }],
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: false,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_OFF_WHITE
                }
            },
            series: {
                pointWidth: pointWidth
            }
        },
        series: [{
                showInLegend: false,
                name: 'Average Unique Connections',
                data: data.connectionsCount,
                color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
                borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
            }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
